import { Button } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import EmptyIcon from '@/shared/assets/empty-icon.svg?react';

interface Props {
  onRefresh: () => void;
}

function VisitHistoryEmptyState({ onRefresh }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-[0.8rem]">
      <div className="w-[6.4rem] h-[6.4rem] flex items-center justify-center text-foreground mb-[2.4rem]">
        <EmptyIcon className="w-[6.4rem] h-[6.4rem]" />
      </div>

      <p className="headline4 text-primary text-center">
        {t('personalAccount.userProfile.visitHistory.emptyState.title')}
      </p>

      <p className="p4 text-secondary text-center mb-[5.2rem]">
        {t('personalAccount.userProfile.visitHistory.emptyState.description')}
      </p>

      <Button size="lg" onClick={onRefresh}>
        {t('personalAccount.userProfile.visitHistory.emptyState.buttonText')}
      </Button>
    </div>
  );
}

export { VisitHistoryEmptyState };
